import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { COUNTRIES_IDS } from 'src/common-panel/constants/country-configs.constants';
import { ServerValueInterpreterService } from 'src/common-panel/services/server-value-interpreter.service';
import { ClinicTypesEnum } from 'src/shop-manager/common/enums/clinic-types-enum';
import { ClinicItemJSON } from 'src/shop-manager/common/models/server-response/clinic-item-json.model';
import { ExcelService } from 'src/shop-manager/services/excel.service';

@Component({
    selector: 'app-convert-csv-to-json-dialog',
    templateUrl: './convert-csv-to-json-dialog.component.html',
    styleUrls: ['./convert-csv-to-json-dialog.component.css'],
    standalone: false
})
export class ConvertCsvToJsonDialogComponent
{
  loaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true)

  form: FormGroup = new FormGroup({
    country: new FormControl({ value: '', disabled: false }, [Validators.required]),
    sheetNumber: new FormControl(),
  })

  fileName: string = '';
  file?: File
  CountriesIDs = COUNTRIES_IDS

  constructor(
    private dialogRef: MatDialogRef<any>,
    private serverValueInterpreterService: ServerValueInterpreterService,
    private excelService: ExcelService
  ) { }

  isDisabledButton(): boolean
  {
    let l_disabled = false
    if (!this.form.valid) l_disabled = true
    return l_disabled
  }

  public async uploadFile(event: any)
  {
    this.file = event.target.files[0];
    this.fileName = this.file!.name;
  }

  public async convertToJSON()
  {
    this.loaded.next(false)
    var l_jsonData
    let geocoder = new google.maps.Geocoder();
    if (this.file)
    {
      this.convertExcelToJson(this.file, this.form.controls['sheetNumber'].value - 1)
        .then((json: any[]) =>
        {
          let l_result: ClinicItemJSON[] = [];
          let l_countryId = this.form.controls['country'].value;
          let l_country = this.serverValueInterpreterService.getFullCountryNameById(l_countryId);
          l_jsonData = json;
          l_jsonData = l_jsonData.filter(l_shop => l_shop.length > 0)
          let l_jsonLength = l_jsonData.length;
          l_jsonData.forEach((l_shop, index) =>
          {
            if (index == 0 || index == 1) return;
            let l_shopType = l_shop[1].toLowerCase();
            let l_location: { longitude: number, latitude: number } = { longitude: 0, latitude: 0 };
            geocoder.geocode({ address: l_shop[3] + ' ' + l_shop[4] + ' ' + l_shop[5] }, (results, status) =>
            {
              let l_state = null;
              if (l_countryId.toUpperCase() == "US" || l_countryId.toUpperCase() == "UV")
              {
                if (l_shop[7]) l_state = l_shop[7]
                else if (results)
                {
                  l_state = results[0].address_components.filter(component => component.types.includes("administrative_area_level_1"))[0].short_name;
                }
              }

              if (results)
              {
                if (results[0].geometry && results[0].geometry.location)
                {
                  l_location.latitude = results[0].geometry.location.lat();
                  l_location.longitude = results[0].geometry.location.lng();
                }
              }

              let l_addressLine2
              if (l_shopType == ClinicTypesEnum.physical)
              {
                if (l_countryId.toUpperCase() == "US" || l_countryId.toUpperCase() == "UV")
                {
                  l_addressLine2 = l_shop[6] + ', ' + l_state + ' ' + l_shop[5]
                } else
                {
                  l_addressLine2 = l_shop[5] + ' ' + l_shop[6]
                }

              } else
              {
                l_addressLine2 = ''
              }

              let l_newShop: ClinicItemJSON = {
                email: l_shop[9] ? l_shop[9] : '–',
                state: l_state,
                zipCode: (l_shopType == ClinicTypesEnum.physical) ? l_shop[5].toString() : "",
                phone: l_shop[8],
                crmType: l_countryId.toUpperCase() == "US" || l_countryId.toUpperCase() == "UV" ? 0 : null,
                openingHours: [
                  [
                    l_shop[10] ? l_shop[10] : '–'
                  ],
                  [
                    l_shop[11] ? l_shop[11] : '–'
                  ],
                  [
                    l_shop[12] ? l_shop[12] : '–'
                  ],
                  [
                    l_shop[13] ? l_shop[13] : '–'
                  ],
                  [
                    l_shop[14] ? l_shop[14] : '–'
                  ],
                  [
                    l_shop[15] ? l_shop[15] : '–'
                  ],
                  [
                    l_shop[16] ? l_shop[16] : '–'
                  ]],
                googleMaps: {
                  geolocation: {
                    longitude: l_location.longitude,
                    latitude: l_location.latitude
                  }
                },
                shopType: l_shopType,
                brandId: this.serverValueInterpreterService.getBrandIdByCountryId(l_countryId),
                city: l_shopType == ClinicTypesEnum.physical ? (l_shop[6] ? l_shop[6] : '–') : '',
                shopId: l_shop[3] ? l_shop[3] : '–',
                appleMaps: {
                  geolocation: {
                    longitude: l_location.longitude,
                    latitude: l_location.latitude
                  }
                },
                presentedForSelection: (l_shopType == ClinicTypesEnum.physical) ? true : false,
                country: l_country,
                addressLine1: l_shopType == ClinicTypesEnum.physical ? (l_shop[4] ? l_shop[4] : '–') : '',
                addressLine2: l_addressLine2,
                shopName: l_shop[2] ? l_shop[2] : '–',
              }

              l_result.push(l_newShop)
              if (l_result.length == l_jsonLength - 2)
              {
                this.downloadJson(l_result);
                this.dialogRef.close();
                this.loaded.next(true)
              }
            })

          })

          console.log('Converted JSON:', l_result);

        })
        .catch(error =>
        {
          console.error('Error converting file:', error);
        });
    }
  }

  public convertExcelToJson(file: File, sheetNumber: number = 1): Promise<any[]>
  {
    return this.excelService.fileToJson(file, sheetNumber);
  }


  downloadJson(shopJson: ClinicItemJSON[])
  {
    var l_shopJsonString = JSON.stringify(shopJson);
    var element = document.createElement('a');
    element.setAttribute('href', "data:text/json;charset=UTF-8," + encodeURIComponent(l_shopJsonString));
    
    element.setAttribute('download', `generated-shops-from-excel-${this.form.controls['country'].value}.json`);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click(); // simulate click
    document.body.removeChild(element);
  }
}
